import router from '../router';
import vars from '../globals';

let cursorState = false;

const $articles = $('.article');

function initCursor() {
	$articles.each((i, article) => {
		let $article = $(article);
		let $articleLayout = $article.find('.article__layout');
		let $closeButton = $article.find('.article__close-button');
		let $clickableElements = $article.find('a, button, .article__related');

		let offsetX = 0;
		let offsetY = 0;

		if (!vars.isEdgeIE) {
			$article.on('mousemove.article', (e) => {
				offsetX = e.offsetX - 15;
				offsetY = e.offsetY - 15;

				$closeButton.css('transform', `translate3d(${offsetX}px, ${offsetY}px, 0)`);
			});
		} else {
			$article.on('mousemove.article', (e) => {
				offsetX = e.offsetX - 15;
				offsetY = e.offsetY - 15;

				$closeButton.css({
					left: `${offsetX}px`,
					top: `${offsetY}px`,
				});
			});
		}

		$article.on('mouseleave.article', () => {
			$closeButton.addClass('is-hidden');
		});

		$article.on('mouseenter.article', () => {
			$closeButton.removeClass('is-hidden');
		});

		$clickableElements.on('mouseenter.article', () => {
			$closeButton.addClass('is-hidden');
		});

		$clickableElements.on('mouseleave.article', () => {
			$closeButton.removeClass('is-hidden');
		});

		$articleLayout.on('click.article', () => {
			router.navigate('/');
		});
	});

	cursorState = true;
}

function destroyCursor() {
	$articles
		.off('.article')
		.find('a, button, .article__layout, .article__related')
		.off('.article');

	cursorState = false;
}

function init() {
	let resizeTimeout = null;

	if (!vars.isMobile()) {
		initCursor();
	}

	vars.$window.on('resize', () => {
		if (resizeTimeout) {
			clearTimeout(resizeTimeout);
		}

		resizeTimeout = setTimeout(() => {
			if (!vars.isMobile() && !cursorState) {
				initCursor();
			} else if (vars.isMobile() && cursorState) {
				destroyCursor();
			}
		}, 500);
	});
}

init();
